import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../types"
import { Error } from "./text-input.component"
import useTranslationHook from "../../hooks/use-translation.hook"

interface Props {
  error: string
  email?: string
  id?: string
}

interface SuccessProps {
  message?: string
}

const ErrorContainer = styled(Error)`
  position: relative;
  top: unset;
  left: 5px;
  margin-top: -10px;
  margin-bottom: 10px;
  grid-area: Error;
  a {
    color: inherit;
    text-decoration: underline;
    cursor: pointer;
  }
`

export const SuccessContainer = styled(ErrorContainer)`
  color: ${({ theme }) => theme.color.success};
`

export const NewsletterSuccess: AppFunctionComponent<SuccessProps> = ({
  message,
}) => {
  const { translate } = useTranslationHook()
  if (message) {
    return <SuccessContainer>{message}</SuccessContainer>
  } else
    return (
      <SuccessContainer>{translate("newsletter-success")}</SuccessContainer>
    )
}

export const NewsletterError: AppFunctionComponent<Props> = ({ error, id }) => {
  if (
    error.includes(
      "has signed up to a lot of lists very recently; we’re not allowing more signups for now"
    )
  ) {
    return (
      <ErrorContainer id={id}>
        Our email service provider thinks you might have subscribed to too many
        newsletters recently. As a precaution, it won't allow any more
        subscriptions, this is to ensure your email is safe.
      </ErrorContainer>
    )
  } else if (error.includes("PUT")) {
    return (
      <ErrorContainer id={id}>
        Please follow{" "}
        <a
          href={process.env.GATSBY_MAILCHIMP_SUBSCRIBE_URL}
          target="_blank"
          rel="noreferrer"
        >
          this
        </a>{" "}
        link to re-subscribe.
      </ErrorContainer>
    )
  } else {
    return <ErrorContainer id={id}>{error}</ErrorContainer>
  }
}

export default NewsletterError
